import {
  INV_GUARANTEE_DISPOSITION,
  CHECKPOINT_ACTIONS,
  RECOMMENDED_DECISION_DISPOSITION,
} from '@signifyd/http'

export const RECOMMENDATION_CHECKPOINT_ACTION = {
  ACCEPT: CHECKPOINT_ACTIONS.ACCEPT,
  REJECT: CHECKPOINT_ACTIONS.REJECT,
  HOLD: CHECKPOINT_ACTIONS.HOLD,
} as const

export type RecommendationCheckpointAction =
  (typeof RECOMMENDATION_CHECKPOINT_ACTION)[keyof typeof RECOMMENDATION_CHECKPOINT_ACTION]

export const RECOMMENDATION_DISPOSITION = {
  ...RECOMMENDED_DECISION_DISPOSITION,
  IN_REVIEW: INV_GUARANTEE_DISPOSITION.IN_REVIEW,
} as const

export type RecommendationDisposition =
  (typeof RECOMMENDATION_DISPOSITION)[keyof typeof RECOMMENDATION_DISPOSITION]

export interface UpdateRecommendationReviewResponse {
  caseId: number
  decisionCount: number
  recommendedAction: RecommendationCheckpointAction
  disposition: RecommendationDisposition
  reviewedAt: string | null
  reviewedBy: string | null
  submittedAt: string
}
